var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreymoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20221 9.29163C10.2022 14.4878 15.8384 12.9657 12.2513 15.0368C8.66406 17.1079 4.07713 15.8788 2.00606 12.2916C-0.065006 8.70443 1.16406 4.1175 4.75125 2.04644C8.33845 -0.0246328 4.20221 4.09547 7.20221 9.29163Z",
    stroke: "#919DA9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreymoon);
export default __webpack_public_path__ + "static/media/greymoon.6f9b6e7a958e1eca039461f48644d318.svg";
export { ForwardRef as ReactComponent };